import {
  DirectoryActionConsts,
  DirectoryNameConsts,
  DirectoryTypeConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { applicationModelNames } from 'client/util/Constants/ApplicationConstants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const { GSUITE, OFFICE365 } = applicationModelNames;

const applicationProtipBannerSettings = {};

const buildCloudDirectoryUrl = type => `${ItemTypeRoutes[ItemTypeConsts.cloudDirectory]}/${type}/${DirectoryActionConsts.create}`;

const googleDisplayName = DirectoryNameConsts[DirectoryTypeConsts.gSuite];
const office365DisplayName = DirectoryNameConsts[DirectoryTypeConsts.office365];

applicationProtipBannerSettings[OFFICE365] = {
  summary: `Set up an ${office365DisplayName} Directory Integration to create and manage ${office365DisplayName} user identities directly in JumpCloud before setting up SAML SSO. This integration:`,
  bullets: [
    `Enables user provisioning, attribute management, and suspension of ${office365DisplayName} users managed in JumpCloud.`,
    `Establishes JumpCloud as the password authority for users in ${office365DisplayName}.`,
    `Gives option to import users from ${office365DisplayName} to JumpCloud.`,
  ],
  cloudDirectoryUrl: buildCloudDirectoryUrl(DirectoryTypeConsts.office365),
  kbArticleUrl: KbArticleUrls.office365IntegrationVsSamlConnector,
};

applicationProtipBannerSettings[GSUITE] = {
  summary: `Use our ${googleDisplayName} Directory Integration to create and manage Google user identities directly in JumpCloud. This integration:`,
  bullets: [
    `Enables user provisioning, attribute management, and suspension of ${googleDisplayName} users managed in JumpCloud.`,
    `Establishes JumpCloud as the password authority for users in ${googleDisplayName}.`,
    `Provides ${googleDisplayName} Distribution Group and Group Membership management from JumpCloud.`,
    `Gives option to import users from ${googleDisplayName} to JumpCloud.`,
  ],
  cloudDirectoryUrl: buildCloudDirectoryUrl(DirectoryTypeConsts.gSuite),
  kbArticleUrl: KbArticleUrls.gSuiteIntegrationVsSamlConnector,
};

export default applicationProtipBannerSettings;
